module.exports = __webpack_public_path__ + "static/media/logo_transparent_inverted.59011a35.png";